import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Label } from "reactstrap";
import { FieldArray } from "formik";
import { routes } from "../gen/General";
import axios from "axios";
import BlkFormik from "../util/BlkFormik";
import { BlkField } from "./BlkField";
import Alerts from "../util/Alerts";
import * as yup from "yup";
import JedaiTooltip from "./JedaiTooltip";
import { NEWS } from "../pages/home/menu/menu-items.constants";

const CONTENT_MAX_LENGTH = 500;
const SHORT_CONTENT_MAX_LENGTH = 30;

export const Banner = () => {
    const [item, setItem] = useState({ itemsGen: [] });
    const alert = React.useRef();
    const name = "itemsGen";
    const RECOMMENDED_MAX_CHARACTERS =
        "Para conservar el mismo tamaño entre todos los Sliders se recomienda utilizar siempre la misma cantidad de caracteres en el texto que es visible al cliente. Cantidad de caracteres permitidos 500";

    const itemBanner = {
        src: "",
        title: "",
        content: "",
        buttonType: "",
        buttonText: "",
        buttonUrl: "",
    };

    useEffect(() => {
        getBanner();
    }, []);

    const getBanner = () => {
        axios
            .get(routes.apiVam + "/banner/obtener/banner")
            .then(resp => {
                setItem(resp.data);
            })
            .catch(err => {
                alert.current.handle_error("Error al consultar" + err);
            });
    };

    const saveBanner = (items, acciones) => {
        axios
            .post(routes.apiVam + "/banner/save/banner", items)
            .then(() => {
                alert.current.show_info("Se ha guardado con éxito");
                acciones.setSubmitting(false);
            })
            .catch(error => {
                alert.current.handle_error("Error al guardar" + error);
                acciones.setSubmitting(false);
            });
    };

    const bannerSchema = createValidation(name);

    return (
        <div className="content ">
            <Alerts ref={alert} />
            <Card className={"mb-4"}>
                <CardBody>
                    <CardTitle tag="h4">{NEWS}</CardTitle>
                    <BlkFormik
                        initialValues={item}
                        onSubmit={saveBanner}
                        enableReinitialize={true}
                        validateOnChange={false}
                        validationSchema={bannerSchema}
                    >
                        {({ values, isSubmitting, submitForm }) => (
                            <>
                                <FieldArray name={name}>
                                    {({ push, remove }) => (
                                        <>
                                            {values[name] && values[name].length > 0 ? (
                                                values[name].map((banner, index) => (
                                                    <div
                                                        key={index}
                                                        aria-multiselectable={true}
                                                        className="card-collapse"
                                                    >
                                                        <br />
                                                        <CardHeader role="tab">
                                                            <div
                                                                data-toggle="collapse"
                                                                className="expanded c-pointer"
                                                                onClick={() => push(itemBanner)}
                                                            >
                                                                {"Sliders"}&nbsp;&nbsp;
                                                                <i className={"fa fa-plus "} />
                                                            </div>
                                                        </CardHeader>

                                                        <div className="table-responsive px-5">
                                                            <br />
                                                            <Label>Tipo</Label>
                                                            <BlkField
                                                                component="select"
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Tipo"
                                                                name={`${name}[${index}].btnType`}
                                                            >
                                                                <option value="1">Imagen</option>
                                                            </BlkField>
                                                            <Label>URL Imagen</Label>
                                                            <BlkField
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Src"
                                                                name={`${name}[${index}].src`}
                                                            />
                                                            {values[name][index].src && (
                                                                <>
                                                                    <Label>Vista Previa</Label>
                                                                    <br />
                                                                    <img
                                                                        src={values[name][index].src}
                                                                        height={"200"}
                                                                        alt={""}
                                                                    />
                                                                    <br />
                                                                </>
                                                            )}
                                                            <Label>
                                                                Titulo{" "}
                                                                <JedaiTooltip message={RECOMMENDED_MAX_CHARACTERS}>
                                                                    <i className={"fa fa-info-circle"} />
                                                                </JedaiTooltip>
                                                            </Label>
                                                            <BlkField
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Titulo"
                                                                name={`${name}[${index}].title`}
                                                                maxLength={CONTENT_MAX_LENGTH}
                                                            />
                                                            <Label>
                                                                Descripción{" "}
                                                                <JedaiTooltip message={RECOMMENDED_MAX_CHARACTERS}>
                                                                    <i className={"fa fa-info-circle"} />
                                                                </JedaiTooltip>
                                                            </Label>
                                                            <BlkField
                                                                className="form-control"
                                                                type="text"
                                                                max={10}
                                                                placeholder="Descripción"
                                                                name={`${name}[${index}].content`}
                                                                maxLength={CONTENT_MAX_LENGTH}
                                                            />

                                                            <Label>Botón</Label>
                                                            <BlkField
                                                                component="select"
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Tipo"
                                                                name={`${name}[${index}].buttonType`}
                                                            >
                                                                <option value="">Seleccionar</option>
                                                                <option value="1">URL</option>
                                                                <option value="2">Tarjeta</option>
                                                            </BlkField>

                                                            <Label>Texto del botón</Label>
                                                            <BlkField
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Texto del botón"
                                                                name={`${name}[${index}].buttonText`}
                                                                maxLength={SHORT_CONTENT_MAX_LENGTH}
                                                            />

                                                            {["1"].includes(values[name][index].buttonType) && (
                                                                <>
                                                                    <Label>URL del botón</Label>
                                                                    <BlkField
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="URL del botón"
                                                                        name={`${name}[${index}].buttonUrl`}
                                                                    />
                                                                </>
                                                            )}

                                                            <br />
                                                            <Button
                                                                color="primary"
                                                                className="mb-3 mr-2"
                                                                onClick={() => remove(index)}
                                                            >
                                                                Eliminar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div aria-multiselectable={true} className="card-collapse">
                                                    <br />
                                                    <CardHeader role="tab">
                                                        <div
                                                            data-toggle="collapse"
                                                            className="expanded c-pointer"
                                                            onClick={() => push(itemBanner)}
                                                        >
                                                            {"Ejec.Cuenta Broker"}&nbsp;&nbsp;
                                                            <i className={"fa fa-plus "} />
                                                        </div>
                                                    </CardHeader>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </FieldArray>
                                <br />
                                <div className="form-group col-lg-6">
                                    <Button
                                        type={"submit"}
                                        color="primary"
                                        className="mb-3 mx-2"
                                        onClick={submitForm}
                                        disabled={isSubmitting}
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </>
                        )}
                    </BlkFormik>
                </CardBody>
            </Card>
        </div>
    );
};

const createValidation = name => {
    return yup.object().shape({
        [name]: yup.array().of(
            yup.object().shape({
                title: yup.string().max(CONTENT_MAX_LENGTH, `Error, ingresar máximo ${CONTENT_MAX_LENGTH} Caracteres`),
                content: yup
                    .string()
                    .max(CONTENT_MAX_LENGTH, `Error, ingresar máximo ${CONTENT_MAX_LENGTH} Caracteres`),
                buttonText: yup
                    .string()
                    .max(SHORT_CONTENT_MAX_LENGTH, `Error, ingresar máximo ${SHORT_CONTENT_MAX_LENGTH} Caracteres`),
            })
        ),
    });
};
